export default {
    tooltip: {
        trigger: 'item'
    },
    legend: {
        top: '5%',
        left: 'center',
    },
    graphic: {
        type: "text",
        left: "45%",
        top: "50%",
        style: {
            text: "费用构成\n0",
            textAlign: "center",
            fill: "#000",
            width: 30,
            height: 30,
            fontSize: 12
        }
    },
    series: [
        {
            name: '费用构成',
            type: 'pie',
            center: ['50%', '55%'],
            radius: ['40%', '70%'],
            avoidLabelOverlap: false,
            itemStyle: {
                normal: {
                    label: {
                        show: false,
                    }
                },
            },
            data: [
                {value: 0, name: '管理费'},
                {value: 0, name: '财务费'},
                {value: 0, name: '销售费'},
            ]
        }
    ]
};
